import { Component, Inject } from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';

enum Controls {
  Reason = 'reason',
}

@Component({
  selector: 'app-generic-reasoning-dialog',
  templateUrl: './generic-reasoning-dialog.component.html',
  styleUrls: ['../../../../../../styles/global/_dialog-styles.scss']
})
export class GenericReasoningDialogComponent {
  readonly Controls = Controls;
  reasoningFormGroup: FormGroup;
  defaultRows = 3;

  constructor(
    public dialogRef: MatDialogRef<GenericReasoningDialogComponent>,
    private formBuilder: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: { heading: string, reason: string }
  ) {
    this.reasoningFormGroup = this.formBuilder.group({
      [Controls.Reason]: new FormControl(data?.reason ?? '', Validators.required)
    });
  }

  onClickSave(): void {
    if (this.reasoningFormGroup.valid) {
      const reason = this.reasoningFormGroup.get(Controls.Reason).value;
      this.dialogRef.close(reason);
    }
  }

  onClickCancel(): void {
    this.dialogRef.close();
  }
}